import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';
import { User } from 'src/types/user/User';
import classNames from 'classnames';
import Avatar from '../Avatar';
import Quote from '../Quote';
import Svg from '../Svg';
import s from './Comment.module.scss';

type Props = {
  title?: ReactNode;
  children: ReactNode;
  user?: User;
  classNameModifier?: string;
};

const Comment: FC<Props> = ({ title, children, user, classNameModifier }) => (
  <div className={getClassName(s, 'root', classNames(classNameModifier))}>
    {title}
    <div className={s.avatarName}>
      {user ? (
        <>
          <Avatar
            user={user}
            classNameModifier="noMargin"
          />
          <span className={s.name}>
            {user?.first_name}
          </span>
        </>
      ) : (
        <Svg
          href="#dolphin-small"
          className={s.icon}
        />
      )}
    </div>
    <div className={s.content}>
      <Quote classNameModifier="pre-line">
        {children}
      </Quote>
    </div>
  </div>
);
export default Comment;
